import styled, { css } from 'styled-components';
import { shade, tint } from 'polished';

export const Container = styled.button`
  ${({ theme, disabled }) => css`
    width: 220px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 1rem;
    background-color: ${theme.colors.tertiary};
    color: #fff;
    border-radius: ${theme.radius.default};
    font-size: ${theme.fontSizes.button};
    font-weight: 400;

    ${disabled
      ? css`
          background-color: ${tint(0.3, theme.colors.tertiary)};
          cursor: not-allowed;
        `
      : css`
          :hover {
            background: ${shade(0.2, theme.colors.tertiary)};
            transition: 0.2s;
          }
        `}
  `}
`;
